import ResizableTableClass from "./ResizableTableClass";

export default {
  data() {
    return {
      resizableMounted: false
    }
  },

  beforeDestroy() {
    if(this.resizableTable) this.resizableTable.unmount()
  },
  methods: {
    mountResizableTable() {
        this.$nextTick(() => {
          setTimeout(() => {
            if(this.data.resizable && (this.mergedData.body.length || this.rows.length)) {
              const fixedColumnLength = this.mergedData.fixedColumns && this.mergedData.fixedColumns.fixedColumnsLeft ? (this.mergedData.fixedColumns.fixedColumnsLeft + 1) : 0;
              if(this.resizableTable) this.resizableTable.unmount()
              this.resizableTable = new ResizableTableClass(this.$refs.datatable, this.mergedData.fixedColumns.enabled, fixedColumnLength, this.onResize)
              this.resizableTable.mount()
              this.resizableMounted = true
            }
          }, 1)
        })
      }
  },
  watch: {
    'data.body': {
      handler(newVal) {
        if(!this.resizableMounted) this.mountResizableTable()
      }
    },
    'data': {
      deep: true,
      handler() {
        if(this.data.resizable && this.resizableTable) {
          if(this.resizableMounted) {
            this.$nextTick(() => {
              setTimeout(() => {
                this.resizableTable.updateTableHeight()
              }, 0)
            })
          }
        }
      }
    }
  }
}